// Generated by Melange

import * as Caml_format from "melange.js/caml_format.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Luxon from "./bindings/Luxon.js";
import * as Luxon$1 from "luxon";

function local(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7) {
  return Luxon$1.DateTime.local(prim0 !== undefined ? Caml_option.valFromOption(prim0) : undefined, prim1 !== undefined ? Caml_option.valFromOption(prim1) : undefined, prim2 !== undefined ? Caml_option.valFromOption(prim2) : undefined, prim3 !== undefined ? Caml_option.valFromOption(prim3) : undefined, prim4 !== undefined ? Caml_option.valFromOption(prim4) : undefined, prim5 !== undefined ? Caml_option.valFromOption(prim5) : undefined, prim6 !== undefined ? Caml_option.valFromOption(prim6) : undefined);
}

function setZone(prim0, prim1) {
  return prim1.setZone(prim0);
}

function startOf(prim0, prim1) {
  return prim1.startOf(prim0);
}

function endOf(prim0, prim1) {
  return prim1.endOf(prim0);
}

function day(prim) {
  return prim.day;
}

function weekday(prim) {
  return prim.weekday;
}

function month(prim) {
  return prim.month;
}

function year(prim) {
  return prim.year;
}

function plus(prim0, prim1) {
  return prim1.plus(prim0.VAL);
}

function minus(prim0, prim1) {
  return prim1.minus(prim0.VAL);
}

function fromString(prim) {
  return Luxon$1.DateTime.fromISO(prim);
}

function fromFormat(prim0, prim1) {
  return Luxon$1.DateTime.fromFormat(prim0, prim1);
}

function fromDateFormat(__x) {
  return Luxon$1.DateTime.fromFormat(__x, "dd.MM.yyyy");
}

function toString(prim) {
  return prim.toISO();
}

function toFormat(prim0, prim1) {
  return prim1.toFormat(prim0);
}

function toLocalFormat(param) {
  return param.toFormat("dd.MM.yyyy HH:mm:ss");
}

function toDateFormat(param) {
  return param.toFormat("dd.MM.yyyy");
}

function toMonthYearFormat(param) {
  return param.toFormat("LLLL yyyy");
}

function toYear(param) {
  return param.toFormat("yyyy");
}

function toMillis(prim) {
  return prim.toMillis();
}

function isValid(prim) {
  return prim.isValid;
}

function setLocale(prim0, prim1) {
  return prim1.setLocale(prim0);
}

function fromMillis(prim) {
  return Luxon$1.DateTime.fromMillis(prim);
}

function fromSeconds(prim) {
  return Luxon$1.DateTime.fromSeconds(prim);
}

function daysLeft(date) {
  const today = local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  const diff = date.diff(today);
  return Caml_format.caml_int_of_string(diff.toFormat("d"));
}

function compare(first_date, second_date) {
  const first_val = first_date.valueOf();
  const second_val = second_date.valueOf();
  return first_val - second_val;
}

function previousMonth(date) {
  return date.minus(({
    NAME: "Duration",
    VAL: Luxon.Duration.from(undefined, undefined, undefined, undefined, 1, undefined, undefined, undefined, undefined)
  }).VAL).month;
}

function monthName(date) {
  const match = date.toFormat("M");
  switch (match) {
    case "1" :
      return "январь";
    case "10" :
      return "октябрь";
    case "11" :
      return "ноябрь";
    case "12" :
      return "декабрь";
    case "2" :
      return "февраль";
    case "3" :
      return "март";
    case "4" :
      return "апрель";
    case "5" :
      return "май";
    case "6" :
      return "июнь";
    case "7" :
      return "июль";
    case "8" :
      return "август";
    case "9" :
      return "сентябрь";
    default:
      return "";
  }
}

export {
  local,
  setZone,
  startOf,
  endOf,
  day,
  weekday,
  month,
  year,
  plus,
  minus,
  fromString,
  fromFormat,
  fromDateFormat,
  toString,
  toFormat,
  toLocalFormat,
  toDateFormat,
  toMonthYearFormat,
  toYear,
  toMillis,
  isValid,
  setLocale,
  fromMillis,
  fromSeconds,
  daysLeft,
  compare,
  previousMonth,
  monthName,
}
/* Luxon Not a pure module */
